import axios from "axios";
import {
  CREATE_CUSTOMER_POST,
  DELETE_CUSTOMER_POST,
  EDIT_CUSTOMER_POST,
  ENABLE_DISABLE_CUSTOMER_POST,
  GET_CUSTOMER_POST,
  GET_CUSTOMER_POST_DETAILS,
} from "../../constants/ApiConstant";
import { ToastMessage } from "../../utils/Helper";
import { optionsDialCode } from "../../constants";

/**
 * get Customer list data
 * @param {paganization params} paramsObj
 * @returns data response
 */

export const get_Customer_Post = (paramsObj) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_CUSTOMER_POST}`, {
      headers: {
        Authorization: jwt_token,
      },
      params: paramsObj,
    })
    .then((res) => res.data);
};

/**
 * add Customer api call
 * @param {form data} formData
 * @returns
 */

export const Create_Customer_Post = (formData) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .post(`${process.env.REACT_APP_API_URL}${CREATE_CUSTOMER_POST}`, formData, {
      headers: { Authorization: jwt_token },
    })
    .then((message) => {
      return message;
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 *enable - disable Customer api call
 * @param {form data as isActive & customerPostId} formData
 * @param {list api call function} refetch
 * @returns true & false
 */

export const Enable_Disable_Customer_Post = (formData, refetch) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}${ENABLE_DISABLE_CUSTOMER_POST}`,
      formData,
      {
        headers: { Authorization: jwt_token },
        params: { customerPostId: formData.customerPostId },
      }
    )
    .then((message) => {
      refetch();
      ToastMessage(message.status, message.data.message);
    })
    .catch((error) => {
      if (error.response) {
        const { status, message } = error?.response?.data || error;
        ToastMessage(status, message);
      }
    });
};

export const Get_Details_Customer_Post = (
  customerPostId,
  setFormData,
  setdialogs
) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_CUSTOMER_POST_DETAILS}`, {
      headers: { Authorization: jwt_token },
      params: { customerPostId },
    })
    .then(async (res) => {
      let data = res.data.payload.data;
      let dialCode = optionsDialCode.find(
        (elem) => elem.code === data.dialCode
      );
      setFormData({
        postType: data?.postType ?? null,
        scheduleDate: data?.scheduleDate.split(" ")[0] ?? null,
        image: data?.url ?? null,
        isGeneralPost: data?.isGeneralPost ?? null,
        customerId: data?.customerId ?? null,
        customerPostId: data?.customerPostId ?? null,
        isWithFrame: data?.isWithFrame ?? null,
        postTitle: data?.postTitle ?? null,
      });
      setdialogs(true);
    });
};

/**
 * update Customer api call
 * @param {form data} formData
 * @param {*} customerPostId
 * @returns
 */

export const Put_Update_Customer_Post = (formData, customerPostId) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .put(`${process.env.REACT_APP_API_URL}${EDIT_CUSTOMER_POST}`, formData, {
      headers: { Authorization: jwt_token },
      params: { customerPostId },
    })
    .then((message) => {
      return message;
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 * delete Customer api call
 * @param {form data} formData
 * @param {*} customerPostId
 * @param {list api call } refetch
 * @returns
 */

export const DELETE_Customer_Post = (customerPostId, refetch) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .delete(`${process.env.REACT_APP_API_URL}${DELETE_CUSTOMER_POST}`, {
      headers: { Authorization: jwt_token },
      params: { customerPostId },
    })
    .then((message) => {
      refetch();
      ToastMessage(message.status, message.data.message);
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

export const Get_Details__Customer_Post = (paramObj) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_CUSTOMER_POST_DETAILS}`, {
      headers: { Authorization: jwt_token },
      params: paramObj,
    })
    .then(async (res) => {
      return res.data.payload.data;
    });
};
